import type { ReactNode } from 'react'

// StreamingBubble is the muted, left-aligned assistant container shown while a reply streams in.
// It takes children so the consuming app supplies its own markdown renderer (the design system does
// not depend on app-level rendering).
export function StreamingBubble({ children }: { children: ReactNode }) {
  return (
    <div className="flex w-full justify-start">
      <div className="max-w-[80%] space-y-1">
        <div className="rounded-lg bg-muted px-4 py-2 text-sm text-foreground">{children}</div>
      </div>
    </div>
  )
}

// StreamingIndicator is the pre-first-token "thinking" state: an optional status line plus three
// bouncing dots. Driven by the backend's Status SSE events (e.g. "Drafting Introduction").
export function StreamingIndicator({ statusMessage }: { statusMessage?: string | null }) {
  const accessibleStatus = statusMessage ?? 'Assistant is thinking'

  return (
    <div className="flex w-full justify-start">
      <div role="status" aria-label={accessibleStatus} className="rounded-lg bg-muted px-4 py-2">
        {statusMessage && <p className="mb-1 text-sm text-muted-foreground">{statusMessage}</p>}
        <div aria-hidden="true" className="flex gap-1 pt-2">
          <span className="size-2 animate-bounce rounded-full bg-muted-foreground/50 [animation-delay:0ms]" />
          <span className="size-2 animate-bounce rounded-full bg-muted-foreground/50 [animation-delay:150ms]" />
          <span className="size-2 animate-bounce rounded-full bg-muted-foreground/50 [animation-delay:300ms]" />
        </div>
      </div>
    </div>
  )
}
